import React from 'react';
import { createRoot } from 'react-dom/client';

import 'antd/dist/antd.css'; // or 'antd/dist/antd.less'
import './styles/tailwind.css';
//locals
import App from './App';
import MaintenanceWhiteLabel from './MaintenanceWhiteLabel';
import { unregister } from './registerServiceWorker';

// NOTE: Toggle this to put the in Maintenance mode
const maintenance = false;

const root = createRoot(document.getElementById('root'));
root.render(maintenance ? <MaintenanceWhiteLabel /> : <App />);
unregister();
